// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.sidebar {
  width: 200px;
  background: #f8f9fa;
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  height: 100vh;
}

.sidebar.collapsed {
  width: 80px;
}

.sidebar-header {
  padding: 5px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 8px; /* reduced gap */
  overflow: hidden;
  padding: 4px 8px; /* optional padding if needed */
}

.logo-icon {
  position: relative;
}

.OndcLogo {
  width: 120px; /* reduced logo width */
  height: auto;
}


.logo-text {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.sidebar-toggle {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.sidebar-toggle:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #333;
}

.search-section {
  padding: 0 20px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.search-container {
  position: relative;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  transition: all 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #38d3f1;
  box-shadow: 0 0 0 3px rgba(13, 202, 240, 0.1);
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 14px;
}

.nav-section {
  flex: 1 1;
  padding: 20px 16px;
  overflow-y: auto;
}

.nav-group {
  margin-bottom: 8px;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.nav-content {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  gap: 12px;
  position: relative;
  z-index: 1;
}

.nav-icon {
  width: 20px;
  height: 20px;
  color: #666;
  transition: color 0.2s ease;
  flex-shrink: 0;
}

.nav-text {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  transition: color 0.2s ease;
  flex: 1 1;
  text-align: left;
}

.chevron {
  width: 16px;
  height: 16px;
  color: #999;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.chevron.expanded {
  transform: rotate(90deg);
}

.nav-link:hover {
  background: rgba(13, 202, 240, 0.08);
}

.nav-link:hover .nav-icon {
  color: #38d3f1;
}

.nav-link.active {
  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%) !important;
  box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3) !important;
}

.nav-link.active .nav-icon,
.nav-link.active .nav-text {
  color: white;
}

.active-indicator {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: white;
  border-radius: 2px 0 0 2px;
}

.active-dot {
  width: 6px;
  height: 6px;
  background: #38d3f1;
  border-radius: 50%;
}

.user-section {
  padding: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  margin-top: auto;
}

.user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(13, 202, 240, 0.05);
  border-radius: 12px;
  transition: background 0.2s ease;
}

.user-card:hover {
  background: rgba(13, 202, 240, 0.08);
}

.user-avatar {
  position: relative;
}

.user-avatar.small {
  margin: 0 auto;
}

.avatar-gradient {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%) !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.status-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #10b981;
  border: 2px solid white;
  border-radius: 50%;
}

.main-content {
  flex: 1 1;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
}



.top-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  position: relative;
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #333;
}

.notification-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ef4444;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

.page-header {
  padding: 15px;
  padding-bottom: 24px;
}

.page-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.page-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.page-subtitle {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.content-card {
  margin: 0 32px 32px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-header {
  padding: 2px 6px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  font-size: 18px !important;
  font-weight: 600;
  color: #1a1a1a;
}

.card-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.card-content {
  padding: 32px;
}

.card-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: rgba(13, 202, 240, 0.05);
  border-radius: 12px;
  transition: transform 0.2s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.feature-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.feature-desc {
  font-size: 14px;
  color: #666;
}

.logout-button {
  width: 70%;
  color: #111827;       /* Almost black text */
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-button:hover {
  color: #000000;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

 .store-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-family: "Segoe UI", sans-serif;
}

.active-store {
  font-size: 14px;
  color: #333;
}

.active-store .label {
  font-weight: 500;
  opacity: 0.7;
}

.active-store .name {
  font-weight: 600;
  margin-left: 6px;
  color: #007bff;
}

.change-store-btn {
  padding: 10px 18px;
  background: linear-gradient(135deg, #007bff, #0056d2);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 91, 234, 0.3);
  transition: all 0.25s ease;
}

.change-store-btn:hover {
  background: linear-gradient(135deg, #0056d2, #003e99);
  box-shadow: 0 6px 14px rgba(0, 91, 234, 0.4);
}

.nav-link.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}




@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: -280px;
    z-index: 1000;
    height: 100vh;
  }

  .sidebar.collapsed {
    left: -80px;
  }

  .main-content {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/hocs/Layout/SidebarNavigation/SidebarNavigation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,gBAAgB;EAC1B,gBAAgB;EAChB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,uBAAuB;EACrC,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,yDAAyD;AAC3D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc,QAAQ,sBAAsB;EAC5C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;CAEC;EACC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;;;;AAKA;EACE;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.sidebar {\n  width: 200px;\n  background: #f8f9fa;\n  backdrop-filter: blur(20px);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  position: relative;\n  height: 100vh;\n}\n\n.sidebar.collapsed {\n  width: 80px;\n}\n\n.sidebar-header {\n  padding: 5px 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.logo-section {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* reduced gap */\n  overflow: hidden;\n  padding: 4px 8px; /* optional padding if needed */\n}\n\n.logo-icon {\n  position: relative;\n}\n\n.OndcLogo {\n  width: 120px; /* reduced logo width */\n  height: auto;\n}\n\n\n.logo-text {\n  max-width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.sidebar-toggle {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #333;\n}\n\n.search-section {\n  padding: 0 20px 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.search-container {\n  position: relative;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px 12px 40px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #38d3f1;\n  box-shadow: 0 0 0 3px rgba(13, 202, 240, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #999;\n  font-size: 14px;\n}\n\n.nav-section {\n  flex: 1;\n  padding: 20px 16px;\n  overflow-y: auto;\n}\n\n.nav-group {\n  margin-bottom: 8px;\n}\n\n.nav-item {\n  position: relative;\n}\n\n.nav-link {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-radius: 12px;\n  transition: all 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.nav-content {\n  display: flex;\n  align-items: center;\n  padding: 8px 10px;\n  gap: 12px;\n  position: relative;\n  z-index: 1;\n}\n\n.nav-icon {\n  width: 20px;\n  height: 20px;\n  color: #666;\n  transition: color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.nav-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  transition: color 0.2s ease;\n  flex: 1;\n  text-align: left;\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  color: #999;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.chevron.expanded {\n  transform: rotate(90deg);\n}\n\n.nav-link:hover {\n  background: rgba(13, 202, 240, 0.08);\n}\n\n.nav-link:hover .nav-icon {\n  color: #38d3f1;\n}\n\n.nav-link.active {\n  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%) !important;\n  box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3) !important;\n}\n\n.nav-link.active .nav-icon,\n.nav-link.active .nav-text {\n  color: white;\n}\n\n.active-indicator {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 20px;\n  background: white;\n  border-radius: 2px 0 0 2px;\n}\n\n.active-dot {\n  width: 6px;\n  height: 6px;\n  background: #38d3f1;\n  border-radius: 50%;\n}\n\n.user-section {\n  padding: 10px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  margin-top: auto;\n}\n\n.user-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(13, 202, 240, 0.05);\n  border-radius: 12px;\n  transition: background 0.2s ease;\n}\n\n.user-card:hover {\n  background: rgba(13, 202, 240, 0.08);\n}\n\n.user-avatar {\n  position: relative;\n}\n\n.user-avatar.small {\n  margin: 0 auto;\n}\n\n.avatar-gradient {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%) !important;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 16px;\n}\n\n.status-indicator {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  background: #10b981;\n  border: 2px solid white;\n  border-radius: 50%;\n}\n\n.main-content {\n  flex: 1;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.top-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.action-btn {\n  position: relative;\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 12px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.action-btn:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #333;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ef4444;\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 16px;\n  text-align: center;\n}\n\n.page-header {\n  padding: 15px;\n  padding-bottom: 24px;\n}\n\n.page-title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.page-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3);\n}\n\n.page-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n}\n\n.page-subtitle {\n  font-size: 16px;\n  color: #666;\n  font-weight: 500;\n}\n\n.content-card {\n  margin: 0 32px 32px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 2px 6px !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card-title {\n  font-size: 18px !important;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.card-badge {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.card-content {\n  padding: 32px;\n}\n\n.card-content p {\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 24px;\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  background: rgba(13, 202, 240, 0.05);\n  border-radius: 12px;\n  transition: transform 0.2s ease;\n}\n\n.feature-item:hover {\n  transform: translateY(-2px);\n}\n\n.feature-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #38d3f1 0%, #38d3f1 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 18px;\n}\n\n.feature-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n}\n\n.feature-desc {\n  font-size: 14px;\n  color: #666;\n}\n\n.logout-button {\n  width: 70%;\n  color: #111827;       /* Almost black text */\n  padding: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-button:hover {\n  color: #000000;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n .store-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n.active-store {\n  font-size: 14px;\n  color: #333;\n}\n\n.active-store .label {\n  font-weight: 500;\n  opacity: 0.7;\n}\n\n.active-store .name {\n  font-weight: 600;\n  margin-left: 6px;\n  color: #007bff;\n}\n\n.change-store-btn {\n  padding: 10px 18px;\n  background: linear-gradient(135deg, #007bff, #0056d2);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0, 91, 234, 0.3);\n  transition: all 0.25s ease;\n}\n\n.change-store-btn:hover {\n  background: linear-gradient(135deg, #0056d2, #003e99);\n  box-shadow: 0 6px 14px rgba(0, 91, 234, 0.4);\n}\n\n.nav-link.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n\n\n\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: -280px;\n    z-index: 1000;\n    height: 100vh;\n  }\n\n  .sidebar.collapsed {\n    left: -80px;\n  }\n\n  .main-content {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
